module.exports = __webpack_public_path__ + "img/rb.2dfcd5cd.jpg";